@if (pageCount > 1) {
  @if (presentationV3()) {
    <div class="pages-counter">
      <button
        class="side-arrows left-side-arrow button-arrows pagination-button"
        [ngClass]="{ 'hide-arrows': !isGalleryOpen() }"
        (click)="onPrevPageClick()"
        [disabled]="currentPage() === 1"
      >
        <mat-icon class="icon">chevron_left</mat-icon>
      </button>
      <div class="page-row">
        @if (!isMobile()) {
          @for (page of getPagesToShow(); track trackPagesByIndex($index, page)) {
            <div class="dot" [ngClass]="{ active: page === currentPage(), 'multiple-dots': pageCount > 10 }"></div>
          }
        }
      </div>

      <button
        class="side-arrows right-side-arrow button-arrows pagination-button"
        [ngClass]="{ 'hide-arrows': !isGalleryOpen() }"
        (click)="onNextPageClick()"
        [disabled]="currentPage() === pageCount"
      >
        <mat-icon class="icon">chevron_right</mat-icon>
      </button>
    </div>
  } @else {
    <div [ngClass]="{ pagination: true, active: isGalleryOpen() }">
      <button
        [ngClass]="{ 'left-side-arrow': sideArrows(), 'button-arrows': sideArrows(), 'pagination-button': true }"
        (click)="onPrevPageClick()"
        [disabled]="currentPage() === 1"
      >
        <mat-icon class="icon">chevron_left</mat-icon>
      </button>
      @if (!isMobile()) {
        <div class="page-row">
          @for (page of getPagesToShow(); track trackPagesByIndex($index, page)) {
            <div class="dot" [ngClass]="{ active: page === currentPage(), 'multiple-dots': pageCount > 10 }"></div>
          }
        </div>
      }

      <button
        [ngClass]="{ 'right-side-arrow': sideArrows(), 'button-arrows': sideArrows(), 'pagination-button': true }"
        (click)="onNextPageClick()"
        [disabled]="currentPage() === pageCount"
      >
        <mat-icon class="icon">chevron_right</mat-icon>
      </button>
    </div>
  }
}
